var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2863 14.063V13.888L21.1113 13.888L12.1054 13.8893L11.9304 13.8893V14.0643V21.1236V21.2803L12.0861 21.2976L21.092 22.2985L21.2863 22.3201V22.1246V14.0643V14.063ZM2.92448 20.1227V20.2793L3.08014 20.2966L9.51293 21.0119L9.70728 21.0335V20.838V14.0643V13.8893L9.53231 13.8893L3.09952 13.888L2.92448 13.888V14.063V20.1227ZM21.2863 3.43088V3.23538L21.092 3.25695L12.0861 4.2566L11.9304 4.27388V4.43053V11.4912V11.6662L12.1054 11.6662L21.1113 11.6649L21.1113 11.4912H21.2863V11.4899V11.3149V3.43088ZM9.53228 4.71615H9.53213L9.51297 4.5435L3.08018 5.25754L2.92448 5.27483V5.43148V11.4912V11.6662H3.09948H9.53228H9.70728V11.4912V4.87409V4.71744V4.71615H9.53228ZM0.701367 3.28517L23.5094 0.750941V24.8045L0.701367 22.2703V3.28517Z",
    fill: "#39CFC6",
    stroke: "white",
    strokeWidth: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindows);
export default __webpack_public_path__ + "static/media/windows.985717ca0cf3311436cd22dbc6fc639c.svg";
export { ForwardRef as ReactComponent };